import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';

@Component({
  selector: 'app-bulk-delete',
  templateUrl: './bulk-delete.component.html',
  styleUrls: ['./bulk-delete.component.scss']
})
export class BulkDeleteComponent {
  @Output() close = new EventEmitter();
  @Output() reload = new EventEmitter();
  btnLoading = false;

  @Input() selectedLeads: any[] = [];

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private toastr: ToastrService,
    private tracker: TrackingService
  ) { }

  handleClosDialog() {
    this.close.emit();
  }


  handleDeleteLeads() {
    this.btnLoading = true;

    const payload = {
      "client_id": this.localStorage.getClientId(),
      "lead_id": this.selectedLeads.map((lead: any) => lead.lead_id)
    }

    this.api.deleteLeadData(payload).subscribe(
      {
        next: (res) => {
          this.btnLoading = false;
          this.toastr.success('Leads deleted successfully');
           // ✅ TRACKING
    const desc = `Lead(s) deleted with payload: ${JSON.stringify(payload)}`;
    this.tracker.track('Delete', 'Lead', desc);

          this.reload.emit();
          this.handleClosDialog();
        },
        error: (err) => {
          this.btnLoading = false;
          this.toastr.error(err.error.message);
        }
      }
    );
  }

}
